// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"4":"b56aadab","96":"1a13f90c","192":"4852e195","290":"b9d90b4e","292":"7bf2efb0","376":"796c5a85","393":"c15847ea","523":"beef1010","540":"8977bee6","545":"919b780b","570":"036a9f5a","573":"8ca24f9f","619":"13d9286c","807":"7f52eeb3","914":"bd54227d"}[chunkId] + ".chunk.js";
};